import Question from "../../components/Question";
import { useNavigate, useLocation } from "react-router-dom";
import MoveButton from "../../components/MoveButton";
import { Grid, Box, useMediaQuery, useTheme } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { setParent as updateParent } from '../../redux/userSlice';
import { MinorUserContext } from "../../context/UserNameProvider";
import { useContext } from "react";
import { moveButtonSx } from "../../lib/uiformatting";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function MinorSoloTreatment() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { returning = false } = location.state || {};
    const user = useSelector((state) => state.user);

    const { isMinor, firstName } = useContext(MinorUserContext);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const textAlignment = isDesktop ? 'center' : 'left';

    const opts = {
        [`Yes, I consent to ${firstName} receiving care without me present`]: true,
        [`No, I do not consent to ${firstName} receiving care without me present`]: false,
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/minor/consent', () =>
            navigate('/minor/consent', { state: { returning: returning } })
        );
    };

    return (
        <Question
            onBack={handleBack}
            title={`Minor solo treatment consent`}
            subtitle={
                <>
                    Do you consent for {firstName} to meet with Piction providers without you present in the virtual meeting room?
                    <br />
                    <br />
                    Note: regardless, the adult will be required to say hello at the beginning.
                </>
            }
            input={
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'column',
                    alignItems: textAlignment,
                    width: '100%'
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: isDesktop ? 'center' : 'flex-start',
                        width: '100%',
                        maxWidth: isDesktop ? '700px' : '100%',
                        gap: "1rem",
                        mt: 2
                    }}>
                        {Object.keys(opts).map((key) => (
                            <Grid item xs={12} key={key}>
                                <MoveButton
                                    onClick={() => {
                                        dispatch(updateParent({ ...user.parent, soloTreatment: opts[key] }));
                                        setPageAndDeferNavigate(dispatch, '/minor/weight', () =>
                                            navigate('/minor/weight', { state: { returning } })
                                        );
                                    }}
                                    title={key}
                                    selected={opts[key] === user.parent.soloTreatment}
                                    sx={{ ...moveButtonSx }}
                                />
                            </Grid>
                        ))}
                    </Box>
                </ Box>
            }
        />
    );
};
